<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="true" granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>
    <right-bar-settings v-if="deviceOwner" @onUpdate="updateMRK"></right-bar-settings>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import columnChartOptions from "@/config/charts/column";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

import RightBarSettings from "./RightBarSettings";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    RightBarSettings
  },
  data() {
    return {
      chartOptions: null,
      selectedPhaseLocal: null,
      deviceOwner: false
    };
  },
  computed: {
    selectedyAxisType() {
      return this.$store.getters.getSettings.yAxisType;
    }
  },

  created() {
    const onyAxisSelect = type => {
      this.$store.commit("setyAxisType", type);
    };

    this.chartOptions = JSON.parse(JSON.stringify(columnChartOptions));
    this.chartOptions.title.text = this.$lang.charts.quarter_hour_maximum_active_power;
    this.chartOptions.yAxis.labels.format = "{value} kW";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} kW</b><br/>";
    this.chartOptions.series = [
      {
        name: "Power maximum",
        type: "column",
        marker: {
          enabled: false
        },
        dashStyle: "Solid",
        data: []
      }
    ];
    this.chartOptions.yAxis.type = this.selectedyAxisType;
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
    this.chartOptions.exporting.buttons.contextButton.menuItems.push(
      "separator"
    );

    this.chartOptions.exporting.buttons.contextButton.menuItems.push({
      textKey: "scalerChange",
      onclick: function() {
        if (this.userOptions.yAxis.type == "logarithmic") {
          this.userOptions.yAxis.type = "linear";
          this.yAxis[0].update({ type: "linear" });
          onyAxisSelect("linear");
        } else {
          this.userOptions.yAxis.type = "logarithmic";
          this.yAxis[0].update({ type: "logarithmic" });
          onyAxisSelect("logarithmic");
        }
      }
    });
  },

  methods: {
    updateMRK(data) {
      const { chart } = this.$refs.areaChart;

      chart.yAxis[0].removePlotLine("mrk");
      chart.yAxis[0].removePlotLine("rk");

      if (data.MRK > 0) {
        chart.yAxis[0].addPlotLine({
          id: "mrk",
          value: data.MRK,
          color: "#e22d6d",
          width: 1,
          zIndex: 1,
          label: {
            text: "MRK",
            style: {
              fontSize: "13px"
            }
          }
        });
      }

      if (data.RK > 0) {
        chart.yAxis[0].addPlotLine({
          id: "rk",
          value: data.RK,
          color: "#fd9c17",
          width: 1,
          zIndex: 1,
          label: {
            text: "RK",
            style: {
              fontSize: "13px"
            }
          }
        });
      }
    },

    onPanelSelect(data) {
      this.deviceOwner = data.device.owner;
      this.$nextTick(() => {
        this.getAPIData(data);
      });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/profile",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          data: "P_MAX",
          phase: "L1,L2,L3",
          from: selected.date.from,
          to: selected.date.to,
          format: "H",
          cumulative: true,
          source: selected.source
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            chart.series[0].setData(
              response.data.data.P_MAX,
              false,
              false,
              false
            );
            // chart.series[1].setData(
            //   response.data.data.E_E.CUM,
            //   false,
            //   false,
            //   false
            // );

            chart.xAxis[0].setExtremes(null, null, true);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        })
        .catch(error => {
          if (error.response.data.code === 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
            chart.series[0].setData([]);
            chart.series[1].setData([]);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>